import { useState } from "react";
import { Button, Card, Col, notification, Row, Typography } from "antd";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router-dom";

import { loginRequest } from "config/authentication.config";

import { useTrackLoginMutation } from "store/general";
import styles from "./Login.module.less";

const { Title } = Typography;

interface LocationStateType {
  from?: string;
}

function Login(): JSX.Element {
  const { t } = useTranslation();
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const isAuthenticated = useIsAuthenticated();
  const [trackLogin] = useTrackLoginMutation();
  const location = useLocation();
  let from = "/";
  const locationState = location.state as LocationStateType;

  if (locationState?.from) {
    from = locationState.from;
  }

  const handleLogin = async () => {
    try {
      setIsLoading(true);
      await instance.loginPopup(loginRequest);
      trackLogin();
    } catch (e) {
      console.log(e);
      notification.error({ message: t("something_went_wrong") });
    } finally {
      setIsLoading(false);
    }
  };

  if (isAuthenticated) {
    const event = new Event("authorityChange");
    document.dispatchEvent(event);
    return <Navigate to={from} replace />;
  }

  return (
    <Row className={styles.container} justify="center" align="middle">
      <Col>
        <Card title={<Title level={4}>{t("login.title")}</Title>}>
          <Button
            type="primary"
            onClick={handleLogin}
            loading={isLoading}
            block
          >
            {t("login.login")}
          </Button>
        </Card>
      </Col>
    </Row>
  );
}

export default Login;
